import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "cctv-installation-and-maintenance-sydney";
const serviceId = 1;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "CCTV Installation & Maintenance Sydney | Ozy Wide Group",
    description:
      "Professional camera installation, upgrades and maintenance for Sydney homes, shops, sites and workplaces.",
    keywords:
      "cctv installation Sydney, security cameras Sydney, CCTV maintenance, surveillance systems, home CCTV, business CCTV, NVR setup, remote viewing",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "CCTV Installation & Maintenance",
    description:
      "Professional camera installation, upgrades and maintenance for Sydney homes, shops, sites and workplaces.",
    points: createServicePoints(
      "Camera coverage and blind spots reviewed",
      "NVR, cabling and remote viewing configured",
      "Maintenance planned for reliable footage",
    ),
    images: createImageItems(images, "CCTV Installation & Maintenance Sydney"),
    content,
  };
